<template>
  <div class="cards">
    <div class="card" v-for="item in data" :key="item.id">
      <div class="card__hero">
        <h2>{{ item.name }}</h2>

        <picture>
          <source
            type="image/webp"
            :srcset="
              `${require(`@/assets/img/${item.img}.webp`)}, ${require(`@/assets/img/${item.img}@2x.webp`)} 2x`
            "
          />
          <source
            type="image/png"
            :srcset="
              `${require(`@/assets/img/${item.img}.png`)}, ${require(`@/assets/img/${item.img}@2x.png`)} 2x, ${require(`@/assets/img/${item.img}@3x.png`)} 3x`
            "
          />
          <img
            type="image/png"
            :src="`${require(`@/assets/img/${item.img}.png`)}`"
            :alt="item.name"
          />
        </picture>
      </div>

      <ul class="card__list">
        <li
          class="card__content"
          v-for="material in item.material"
          :key="material.id"
        >
          <div>
            <div class="card__icon" :class="`card__icon--${material.color}`">
              <IconRecycle class="icon" />

              <div class="card__code-number">{{ material.codeNumber }}</div>
            </div>
            <div class="card__code-name">{{ material.codeName }}</div>
          </div>
        </li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconRecycle from '@/assets/svg/icon_recycle.svg'
export default {
  name: 'MaterialCard',
  components: {
    IconRecycle
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return {
          eMsg: 'Žádná data'
        }
      }
    }
  },
  data() {
    return {
      isCardModalOpen: false
    }
  },
  methods: {
    toggleModal() {
      this.isCardModalOpen
        ? (this.isCardModalOpen = true)
        : (this.isCardModalOpen = false)
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../less/core/breakpoints.less);
@import url(../less/core/var.less);

.card {
  background-color: @w;
  margin: 0 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.4rem 0.9rem rgba(0, 0, 0, 0.13);
  margin: 0 0 2rem 0;
  width: 100%;
  @media @lg {
  }
}

.card__hero {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 17rem;
  &:after {
    border-radius: 0.5rem 0.5rem 0 0;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.44);
    z-index: 10;
  }
  h2 {
    text-align: center;
    position: relative;
    z-index: 15;
    color: #fff;
    text-transform: uppercase;
    font-weight: 700;
    max-width: 20rem;
    &:before {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      padding: 2rem;
      z-index: 10;
      border: 0.2rem solid #fff;
    }
  }

  img {
    border-radius: 0.5rem 0.5rem 0 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
}

.card__icon {
  position: relative;
  color: #4c4c4c;
  svg {
    height: 6rem;
    width: 6rem;
    @media @xs {
      height: 4rem;
      width: 4rem;
    }
    @media @sm {
      height: 6rem;
      width: 6rem;
    }

    fill: #4c4c4c;
  }

  .card__code-number {
    position: absolute;
    left: 50%;
    top: 43%;
    transform: translate(-50%, -43%);
  }
}

.card__icon--green {
  svg {
    fill: #2c6e2e;
  }
}

.card__code-number {
  font-size: 1.5rem;
  font-weight: 700;
}

.card__code-name {
  text-align: center;
  width: 100%;
  font-weight: 700;
  text-transform: uppercase;
  min-height: 1.8rem;
}

.card-modal__close {
  cursor: pointer;
}

.card__list {
  padding: 2rem 1rem;
  list-style-type: none;
  margin: 0.2rem 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  > li {
    width: calc(~'25% - 1rem');
  }
}

.card__content {
  margin-bottom: 2rem;
  display: flex;

  align-items: center;
  justify-content: center;
}

.icon--yellow {
  fill: yellow;
}

.icon--blue {
  fill: yellow;
}

.icon--orange {
  fill: yellow;
}

.icon--brown {
  fill: yellow;
}

.icon--white {
  fill: yellow;
}

.icon--green {
  fill: yellow;
}

.card--yellow {
  background-color: yellow;
}

.card--blue {
  background-color: #093dbd;
  color: @w;
}

.card--orange {
  background-color: orange;
}

.card--brown {
  background-color: brown;
}

.card--wite {
  background-color: white;
}
</style>
